import React from 'react'
import { useForm } from "react-hook-form";
import GoogleAuth from '../../containers/GoogleAuth';

const VerifyUserOtpComponent = (props) => {

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    return (
        <>
            <div className="modal-dialog modal-dialog-centered z-index-999" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                    OTP Information / Renseignements sur le mot de passe à usage unique 
                        {/* <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => props.closeRemoveModal()}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button> */}
                    </div>
                    <div className="modal-body">
                        <form
                            onSubmit={handleSubmit(props.handleSubmit)}
                        >
                            {/* <div className="alert alert-warning">
                                We have sent to verification code on your registered email./Nous avons envoyé au code de vérification sur votre e-mail enregistré.
                            </div> */}
                            <div className="form-group">
                                <label className="text-label">Enter Verification Code / Entrez le code de vérification
                                <span size="5" className="error-star">
                                        *
                                </span>
                                </label>
                                <input
                                    type="text"
                                    name="OTP"
                                    className="form-control"
                                    placeholder="Enter Verification Code / Entrez le code de vérification"
                                    {...register("OTP", { required: true })}
                                />
                                <small className="text-danger">{errors.OTP?.type === 'required' && "OTP is required"}</small>
                            </div>
                            <div className="text-right">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value="Submit / Soumettre"
                                />
                            </div>
                        </form>
                        {/* <div className='divider'></div>
                        <div className='authContainer'>
                            <GoogleAuth email={"flawless.jayt@gmail.com"} />
                        </div> */}
                    </div>
                </div >
                
            </div >
        </>
    );
};
export default VerifyUserOtpComponent;
